import { useLang } from "@/i18n/LanguageContext";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import DemoDialog from "./DemoDialog";
import { track, REGISTER_URL } from "@/lib/analytics";

const CtaBand = () => {
  const { t } = useLang();
  return (
    <section id="cta" className="py-24 md:py-32 bg-background">
      <div className="container">
        <div className="relative overflow-hidden rounded-[2rem] bg-gradient-primary px-8 py-16 md:px-16 md:py-24 text-primary-foreground shadow-elegant">
          <div className="absolute -top-20 -right-20 h-72 w-72 rounded-full bg-coral/40 blur-3xl" />
          <div className="absolute -bottom-20 -left-20 h-72 w-72 rounded-full bg-primary-foreground/10 blur-3xl" />
          <div className="relative max-w-2xl">
            <h2 className="text-3xl sm:text-4xl md:text-6xl font-extrabold leading-[1.05]">{t.cta.title}</h2>
            <p className="mt-4 text-lg md:text-xl opacity-90">{t.cta.desc}</p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a href={REGISTER_URL} target="_blank" rel="noopener noreferrer" onClick={() => track("register_click", "cta_band")}>
                <Button size="lg" variant="secondary" className="rounded-full h-12 px-7 text-base font-bold w-full sm:w-auto">
                  {t.cta.button} <ArrowRight className="ml-1 h-4 w-4" />
                </Button>
              </a>
              <DemoDialog
                trigger={
                  <Button size="lg" variant="outline" className="rounded-full h-12 px-7 text-base font-bold bg-transparent border-primary-foreground/40 text-primary-foreground hover:bg-primary-foreground hover:text-primary">
                    {t.cta.secondary}
                  </Button>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaBand;
